var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloLink } from 'apollo-link';
import { mergeConfig } from '../logic/config';
import { getValidToken } from '../logic/auth';
export var targetSiteLink = function (config) {
    var c = mergeConfig(config);
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.request = function (operation, forward) {
            var additionalHeaders = {
                'X-Target-Site': c.TARGET_SITE,
            };
            var token = getValidToken();
            if (token) {
                additionalHeaders.authorization = token;
            }
            operation.setContext(function (context) { return (__assign(__assign({}, context), { headers: __assign(__assign({}, context.headers), additionalHeaders) })); });
            return forward(operation);
        };
        return class_1;
    }(ApolloLink));
};
//# sourceMappingURL=targetSiteLink.js.map